/* "Your pack": image 1 of the curated supplement gallery (snippets/kv-curated-gallery.liquid) shows exactly the
   pack(s) the chosen weight and plan send. It reads the selector's own plan table (#kv-wps-data-<section>) and its
   pressed weight and plan buttons, so kv-weight-plan-selector.js needs no change. */
(function () {
  var LABEL = {
    '120': '120 g, 15 scoops',
    '240': '240 g, 30 scoops',
    '480': '480 g, 60 scoops',
    '240p480': '240 g + 480 g, 90 scoops',
    '2x480': '2 × 480 g, 120 scoops',
    '3x480': '3 × 480 g, 180 scoops',
    '4x480p240': '4 × 480 g + 240 g, 270 scoops'
  };

  function packKey(items) {
    var q = { '120g': 0, '240g': 0, '480g': 0 };
    items.forEach(function (it) { q[it.title] = (q[it.title] || 0) + it.qty; });
    if (!q['480g']) return q['240g'] ? '240' : '120';
    if (q['480g'] === 1) return q['240g'] ? '240p480' : '480';
    return q['480g'] + 'x480' + (q['240g'] ? 'p240' : '');
  }

  function init(gallery) {
    var slide = gallery.querySelector('[data-kv-pack]');
    if (!slide || slide.hasAttribute('data-kv-ready')) return;
    slide.setAttribute('data-kv-ready', '');
    var sid = gallery.getAttribute('data-section');
    var packs, plans;
    try { packs = JSON.parse(slide.getAttribute('data-kv-pack')); } catch (e) { return; }
    try { plans = JSON.parse(document.getElementById('kv-wps-data-' + sid).textContent).planConfig; } catch (e) { return; }
    if (!plans) return;
    var root = gallery.closest('.shopify-section') || document;
    var img = slide.querySelector('.product__media img');
    var thumb = gallery.querySelector('[data-target="' + sid + '-kvpack"] img');
    var modalImg = document.querySelector('#ProductModal-' + sid + ' [data-kv-pack-modal]');

    function apply() {
      var w = root.querySelector('[data-weight-btn][aria-pressed="true"]');
      var p = root.querySelector('[data-plan-btn][aria-pressed="true"]');
      if (!w || !p) return;
      var cfg = (plans[w.getAttribute('data-weight-btn')] || {})[p.getAttribute('data-plan-btn')];
      if (!cfg || !cfg.items) return;
      var key = packKey(cfg.items);
      if (!packs[key] || key === slide.getAttribute('data-kv-key')) return;
      slide.setAttribute('data-kv-key', key);
      var alt = 'Your pack: ' + LABEL[key];
      if (img) { img.src = packs[key][0]; img.alt = alt; }
      if (thumb) { thumb.src = packs[key][1]; thumb.alt = alt; }
      if (modalImg) { modalImg.src = packs[key][0]; modalImg.alt = alt; }
    }

    new MutationObserver(apply).observe(root, { subtree: true, attributes: true, attributeFilter: ['aria-pressed'] });
    apply();
  }

  function run() {
    document.querySelectorAll('media-gallery[data-kv-curated]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
